export const CONSTANTS = {
  SUPPORT_EMAIL: 'tonesupport@gmail.com',
  SUPER_ADMIN_MODULE: 5,
  CLIENT_TYPE: ['demo', 'live', 'both'],
  DEFAULT_PRIMARY_COLOR: '#143f6f',
  DEFAULT_SECONDARY_COLOR: '#0d97fd',
  INACTIVITY_TIMEOUT: 10 * 60 * 1000,
  TONE_PORTAL: 'TONE Portal',
  EXPORT_OPTION: [
    { label: 'CSV', value: 'csv' },
    { label: 'Excel', value: 'excel' },
    { label: 'PDF', value: 'pdf' },
  ],
  ROW_LIMITS: [10, 25, 50, 100, 250, 500],
};
